/* tslint:disable */
/* eslint-disable */
/**
 * Micro Interactions B Service
 * API for micro-interactions
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
  ApiMicroInteraction,
  ApiMicroInteractionFromJSON,
  ApiMicroInteractionToJSON,
  ApiMicroInteractionComplete,
  ApiMicroInteractionCompleteFromJSON,
  ApiMicroInteractionCompleteToJSON,
  ApiMicroInteractionDismiss,
  ApiMicroInteractionDismissFromJSON,
  ApiMicroInteractionDismissToJSON,
  ApiMicroInteractionMetadata,
  ApiMicroInteractionMetadataFromJSON,
  ApiMicroInteractionMetadataToJSON,
  ApiMicroInteractionUpdate,
  ApiMicroInteractionUpdateFromJSON,
  ApiMicroInteractionUpdateToJSON,
} from '../models';

export interface CompleteMicroInteractionRequest {
  apiMicroInteractionComplete: ApiMicroInteractionComplete;
  xChewyAuthIDToken?: string;
  xChewyAuthAccessToken?: string;
  undo?: boolean;
}

export interface DismissMicroInteractionRequest {
  apiMicroInteractionDismiss: ApiMicroInteractionDismiss;
  xChewyAuthIDToken?: string;
  xChewyAuthAccessToken?: string;
  undo?: boolean;
}

export interface GetAdminMicroInteractionMetadataRequest {
  xChewyAuthIDToken?: string;
  xChewyAuthAccessToken?: string;
  petProfileId?: number;
  id?: number;
}

export interface GetMicroInteractionRequest {
  xChewyAuthIDToken?: string;
  xChewyAuthAccessToken?: string;
  enableMicroInteraction?: string;
  clientPlatformType?: GetMicroInteractionClientPlatformTypeEnum;
  clientPlatformVersion?: string;
  clientPage?: GetMicroInteractionClientPageEnum;
  id?: number;
  petId?: number;
  orderId?: number;
  itemIds?: Array<number>;
  itemCategoryIds?: Array<number>;
}

export interface GetMicroInteractionMetadataRequest {
  xChewyAuthIDToken?: string;
  xChewyAuthAccessToken?: string;
}

export interface PatchAdminMicroInteractionRequest {
  apiMicroInteractionUpdate: ApiMicroInteractionUpdate;
  xChewyAuthIDToken?: string;
  xChewyAuthAccessToken?: string;
}

export interface ValidateMicroInteractionRequest {
  body: string;
}

/**
 *
 */
export class MicroInteractionsApi extends runtime.BaseAPI {
  /**
   * update mint status in dynamodb
   * update MINT record status to complete
   */
  async completeMicroInteractionRaw(
    requestParameters: CompleteMicroInteractionRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<ApiMicroInteractionMetadata>> {
    if (
      requestParameters.apiMicroInteractionComplete === null ||
      requestParameters.apiMicroInteractionComplete === undefined
    ) {
      throw new runtime.RequiredError(
        'apiMicroInteractionComplete',
        'Required parameter requestParameters.apiMicroInteractionComplete was null or undefined when calling completeMicroInteraction.',
      );
    }

    const queryParameters: any = {};

    if (requestParameters.undo !== undefined) {
      queryParameters['undo'] = requestParameters.undo;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (
      requestParameters.xChewyAuthIDToken !== undefined &&
      requestParameters.xChewyAuthIDToken !== null
    ) {
      headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
    }

    if (
      requestParameters.xChewyAuthAccessToken !== undefined &&
      requestParameters.xChewyAuthAccessToken !== null
    ) {
      headerParameters['X-Chewy-Auth-Access-Token'] = String(
        requestParameters.xChewyAuthAccessToken,
      );
    }

    const response = await this.request(
      {
        path: `/v1/mi/complete`,
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: ApiMicroInteractionCompleteToJSON(requestParameters.apiMicroInteractionComplete),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiMicroInteractionMetadataFromJSON(jsonValue),
    );
  }

  /**
   * update mint status in dynamodb
   * update MINT record status to complete
   */
  async completeMicroInteraction(
    requestParameters: CompleteMicroInteractionRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<ApiMicroInteractionMetadata> {
    const response = await this.completeMicroInteractionRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * update mint status in dynamodb
   * update MINT record status to dismiss
   */
  async dismissMicroInteractionRaw(
    requestParameters: DismissMicroInteractionRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<ApiMicroInteractionMetadata>> {
    if (
      requestParameters.apiMicroInteractionDismiss === null ||
      requestParameters.apiMicroInteractionDismiss === undefined
    ) {
      throw new runtime.RequiredError(
        'apiMicroInteractionDismiss',
        'Required parameter requestParameters.apiMicroInteractionDismiss was null or undefined when calling dismissMicroInteraction.',
      );
    }

    const queryParameters: any = {};

    if (requestParameters.undo !== undefined) {
      queryParameters['undo'] = requestParameters.undo;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (
      requestParameters.xChewyAuthIDToken !== undefined &&
      requestParameters.xChewyAuthIDToken !== null
    ) {
      headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
    }

    if (
      requestParameters.xChewyAuthAccessToken !== undefined &&
      requestParameters.xChewyAuthAccessToken !== null
    ) {
      headerParameters['X-Chewy-Auth-Access-Token'] = String(
        requestParameters.xChewyAuthAccessToken,
      );
    }

    const response = await this.request(
      {
        path: `/v1/mi/dismiss`,
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: ApiMicroInteractionDismissToJSON(requestParameters.apiMicroInteractionDismiss),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiMicroInteractionMetadataFromJSON(jsonValue),
    );
  }

  /**
   * update mint status in dynamodb
   * update MINT record status to dismiss
   */
  async dismissMicroInteraction(
    requestParameters: DismissMicroInteractionRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<ApiMicroInteractionMetadata> {
    const response = await this.dismissMicroInteractionRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get all MINT metadata records for auth user from dynamoDB
   * Get MINT metadata records
   */
  async getAdminMicroInteractionMetadataRaw(
    requestParameters: GetAdminMicroInteractionMetadataRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<Array<ApiMicroInteractionMetadata>>> {
    const queryParameters: any = {};

    if (requestParameters.petProfileId !== undefined) {
      queryParameters['petProfileId'] = requestParameters.petProfileId;
    }

    if (requestParameters.id !== undefined) {
      queryParameters['id'] = requestParameters.id;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.xChewyAuthIDToken !== undefined &&
      requestParameters.xChewyAuthIDToken !== null
    ) {
      headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
    }

    if (
      requestParameters.xChewyAuthAccessToken !== undefined &&
      requestParameters.xChewyAuthAccessToken !== null
    ) {
      headerParameters['X-Chewy-Auth-Access-Token'] = String(
        requestParameters.xChewyAuthAccessToken,
      );
    }

    const response = await this.request(
      {
        path: `/v1/admin/mi/metadata`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ApiMicroInteractionMetadataFromJSON),
    );
  }

  /**
   * Get all MINT metadata records for auth user from dynamoDB
   * Get MINT metadata records
   */
  async getAdminMicroInteractionMetadata(
    requestParameters: GetAdminMicroInteractionMetadataRequest = {},
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<Array<ApiMicroInteractionMetadata>> {
    const response = await this.getAdminMicroInteractionMetadataRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get Micro interaction the user is eligible for
   * Get Eligible Micro Interaction
   */
  async getMicroInteractionRaw(
    requestParameters: GetMicroInteractionRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<ApiMicroInteraction>> {
    const queryParameters: any = {};

    if (requestParameters.enableMicroInteraction !== undefined) {
      queryParameters['enableMicroInteraction'] = requestParameters.enableMicroInteraction;
    }

    if (requestParameters.clientPlatformType !== undefined) {
      queryParameters['client_platform_type'] = requestParameters.clientPlatformType;
    }

    if (requestParameters.clientPlatformVersion !== undefined) {
      queryParameters['client_platform_version'] = requestParameters.clientPlatformVersion;
    }

    if (requestParameters.clientPage !== undefined) {
      queryParameters['client_page'] = requestParameters.clientPage;
    }

    if (requestParameters.id !== undefined) {
      queryParameters['id'] = requestParameters.id;
    }

    if (requestParameters.petId !== undefined) {
      queryParameters['pet_id'] = requestParameters.petId;
    }

    if (requestParameters.orderId !== undefined) {
      queryParameters['order_id'] = requestParameters.orderId;
    }

    if (requestParameters.itemIds) {
      queryParameters['item_ids'] = requestParameters.itemIds;
    }

    if (requestParameters.itemCategoryIds) {
      queryParameters['item_category_ids'] = requestParameters.itemCategoryIds;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.xChewyAuthIDToken !== undefined &&
      requestParameters.xChewyAuthIDToken !== null
    ) {
      headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
    }

    if (
      requestParameters.xChewyAuthAccessToken !== undefined &&
      requestParameters.xChewyAuthAccessToken !== null
    ) {
      headerParameters['X-Chewy-Auth-Access-Token'] = String(
        requestParameters.xChewyAuthAccessToken,
      );
    }

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('chewyBearerAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/v1/mi`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiMicroInteractionFromJSON(jsonValue),
    );
  }

  /**
   * Get Micro interaction the user is eligible for
   * Get Eligible Micro Interaction
   */
  async getMicroInteraction(
    requestParameters: GetMicroInteractionRequest = {},
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<ApiMicroInteraction> {
    const response = await this.getMicroInteractionRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get all MINT metadata records for auth user from dynamoDB
   * Get MINT metadata records
   */
  async getMicroInteractionMetadataRaw(
    requestParameters: GetMicroInteractionMetadataRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<Array<ApiMicroInteractionMetadata>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.xChewyAuthIDToken !== undefined &&
      requestParameters.xChewyAuthIDToken !== null
    ) {
      headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
    }

    if (
      requestParameters.xChewyAuthAccessToken !== undefined &&
      requestParameters.xChewyAuthAccessToken !== null
    ) {
      headerParameters['X-Chewy-Auth-Access-Token'] = String(
        requestParameters.xChewyAuthAccessToken,
      );
    }

    const response = await this.request(
      {
        path: `/v1/mi/metadata`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ApiMicroInteractionMetadataFromJSON),
    );
  }

  /**
   * Get all MINT metadata records for auth user from dynamoDB
   * Get MINT metadata records
   */
  async getMicroInteractionMetadata(
    requestParameters: GetMicroInteractionMetadataRequest = {},
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<Array<ApiMicroInteractionMetadata>> {
    const response = await this.getMicroInteractionMetadataRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * patch request to update a record for dynamodb
   * update mint record
   */
  async patchAdminMicroInteractionRaw(
    requestParameters: PatchAdminMicroInteractionRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<ApiMicroInteractionMetadata>> {
    if (
      requestParameters.apiMicroInteractionUpdate === null ||
      requestParameters.apiMicroInteractionUpdate === undefined
    ) {
      throw new runtime.RequiredError(
        'apiMicroInteractionUpdate',
        'Required parameter requestParameters.apiMicroInteractionUpdate was null or undefined when calling patchAdminMicroInteraction.',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (
      requestParameters.xChewyAuthIDToken !== undefined &&
      requestParameters.xChewyAuthIDToken !== null
    ) {
      headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
    }

    if (
      requestParameters.xChewyAuthAccessToken !== undefined &&
      requestParameters.xChewyAuthAccessToken !== null
    ) {
      headerParameters['X-Chewy-Auth-Access-Token'] = String(
        requestParameters.xChewyAuthAccessToken,
      );
    }

    const response = await this.request(
      {
        path: `/v1/admin/mi/metadata`,
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: ApiMicroInteractionUpdateToJSON(requestParameters.apiMicroInteractionUpdate),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiMicroInteractionMetadataFromJSON(jsonValue),
    );
  }

  /**
   * patch request to update a record for dynamodb
   * update mint record
   */
  async patchAdminMicroInteraction(
    requestParameters: PatchAdminMicroInteractionRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<ApiMicroInteractionMetadata> {
    const response = await this.patchAdminMicroInteractionRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Validate Micro Interaction json file
   * Validate Micro Interaction
   */
  async validateMicroInteractionRaw(
    requestParameters: ValidateMicroInteractionRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<ApiMicroInteraction>> {
    if (requestParameters.body === null || requestParameters.body === undefined) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling validateMicroInteraction.',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('chewyBearerAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/v1/mi`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters.body as any,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiMicroInteractionFromJSON(jsonValue),
    );
  }

  /**
   * Validate Micro Interaction json file
   * Validate Micro Interaction
   */
  async validateMicroInteraction(
    requestParameters: ValidateMicroInteractionRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<ApiMicroInteraction> {
    const response = await this.validateMicroInteractionRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const GetMicroInteractionClientPlatformTypeEnum = {
  Web: 'web',
  Ios: 'ios',
  Android: 'android',
} as const;
export type GetMicroInteractionClientPlatformTypeEnum = typeof GetMicroInteractionClientPlatformTypeEnum[keyof typeof GetMicroInteractionClientPlatformTypeEnum];
/**
 * @export
 */
export const GetMicroInteractionClientPageEnum = {
  Home: 'home',
  HomeFlex: 'home_flex',
  Account: 'account',
  PetProfileView: 'pet_profile_view',
  Typ: 'typ',
} as const;
export type GetMicroInteractionClientPageEnum = typeof GetMicroInteractionClientPageEnum[keyof typeof GetMicroInteractionClientPageEnum];
